<template>
  <div class="gui-flex gui-flex-rows">
    <div class="table-border__radius elevation-1 mb-3">
      <v-data-table
        :headers="headers"
        :items="polozky"
        hide-controls
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.produkt.nazev }}</td>
          <td>{{ props.item.datum | formatSimpleDate }}</td>
          <td>Předávací protokol č. {{ props.item.predavaci_protokol }}</td>
          <td><span v-if="props.item.zpusob_doruceni != null">{{ props.item.zpusob_doruceni.nazev }}</span></td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        { text: 'Produkt', value: 'produkt', sortable: false },
        { text: 'Datum', value: 'datum', sortable: false },
        { text: 'Předávací protokol', value: 'predavaci_protokol', sortable: false },
        { text: 'Způsob předání', value: 'zpusob_predani', sortable: false }
      ],
      items: [
        {
          produkt: 'Lorem',
          datum: '2. 1. 2019',
          predavaci_protokol: 'Lorem',
          zpusob_predani: 'Osobní'
        }
      ]
    }
  },
  mounted: function() {

  },
  props: {
    id: String,
    polozky: Array
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/PredaneProdukty.vue